import { IconHelp } from '@tabler/icons-react';
import { ReactNode } from 'react';

import { ZorroGroup } from '../Group';
import { ZorroIcon } from '../Icon';
import { ITextProps, ZorroText } from '../Text';
import { Tooltip } from '../v2/Tooltip';

type Props = {
  label: string;
  tooltipLabel?: ReactNode;
  isRequired?: boolean;
  isDisabled?: boolean;
  hasError?: boolean;
  color?: ITextProps['c'];
};

export const ZorroLabelWithTooltip = ({
  label,
  tooltipLabel,
  isRequired,
  isDisabled,
  hasError,
  color,
}: Props) => {
  return (
    <ZorroGroup gap="0.25rem" h="1.25rem">
      <ZorroText size="sm" c={color}>
        {label}
        {isRequired && (
          <span
            style={{
              color: hasError ? 'var(--color-text-error-primary)' : 'inherit',
            }}
          >
            *
          </span>
        )}
      </ZorroText>
      {tooltipLabel && (
        <Tooltip label={tooltipLabel} position="top" disabled={isDisabled}>
          <ZorroGroup pos="relative">
            {!isDisabled && (
              <ZorroIcon
                icon={IconHelp}
                size="1rem"
                color="#676979"
                cursor="pointer"
              />
            )}
          </ZorroGroup>
        </Tooltip>
      )}
    </ZorroGroup>
  );
};
